import React, { useRef } from 'react';
import PostList from 'post/PostList';

export const PostListPage = () => {
  const mounted = useRef(false);
  // const listRef = useRef(null);

  // useEffect(() => {
  //   if (mounted.current) return;
  //   mounted.current = true;

  //   // const savedY = sessionStorage.getItem('scrollY');
  //   // if (savedY && listRef.current) {
  //   //   console.log(savedY);
  //   //   listRef.current.scrollTop = parseInt(savedY);
  //   // }

  //   // return () => {
  //   //   if (listRef.current) {
  //   //     sessionStorage.setItem('scrollY', listRef.current.scrollTop);
  //   //   }
  //   // }
  // }, [loading, navigate, user]);
  
  return (
    <div className="PostListPage">
      <PostList/>
    </div>
  );
};